import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import QrCSS from "../css/Qr.module.css";

function Qr() {
  return (
    <div className={QrCSS.page}>
      <Header />
      <main className={QrCSS.main}>
        <img
          src="/isla-portfolio-vercel-qr.png"
          alt="QR code for isla-portfolio.vercel.app"
          className={QrCSS.image}
        />
        <a
          href="https://isla-portfolio.vercel.app"
          className={QrCSS.link}
          target="_blank"
          rel="noreferrer"
        >
          isla-portfolio.vercel.app
        </a>
      </main>
      <Footer />
    </div>
  );
}

export default Qr;
